
import * as ProtocolsStore from '../../../redux/middleware/MedicalProtocolMiddleware';
import * as ProvidersStore from '../../../redux/middleware/ProviderMiddleware';
import * as ProtocolConsumptionStore from '../../../redux/middleware/ProtocolConsumptionMiddleware';
import { AppState } from '../../../redux/reducers';
import { ErrorType } from '../../../models/HttpError';
import { Protocol } from '../../../models/Entities/Protocols/Protocol';
import { ProtocolConsumption } from '../../../models/Entities/Protocols/ProtocolConsumption';

interface IProps {
  ProtocolId: number | undefined;
  CosnumptionId: string | undefined;
}

interface ConnectedProps {
  isLoading: boolean;
  successLoading: boolean | undefined;
  error: ErrorType | null;
  protocol?: Protocol | null;
  Consumptions: ProtocolConsumption[];
  ParentGroupingId?: string | undefined;
  ProviderId?: number | undefined;
}

interface DispatchProps {
  GetMedicalProtocolById: typeof ProtocolsStore.actionCreators.GetMedicalProtocolById;
  GetAllProtocolConsumptionsByProtocol: typeof ProtocolConsumptionStore.ActionCreators.GetAllProtocolConsumptionsByProtocol;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => {
  const AuxProtocol: Protocol | null = state.MedicalProtocols?.list?.find((p: Protocol) => p.id === ownProps.ProtocolId) ?? null;
  // Filter directly from protocol consumptions by parentGroupingId; visit context not required
  const AuxConsumption: ProtocolConsumption | null = (AuxProtocol?.consumptions || undefined)?.find((c: ProtocolConsumption) => c.id === ownProps.CosnumptionId) || null;

  return {
    isLoading: AuxProtocol?.isGettingConsumptions || false,
    successLoading: state.MedicalProtocols?.LoadingAllConsumptionsSuccess || undefined,
    // Child list does not surface complex errors; normalize to null or cast when available
    error: null,
    Consumptions: AuxConsumption?.childConsumption || [],
    ParentGroupingId: AuxConsumption?.groupingId,
    protocol: AuxProtocol,
    ProviderId: undefined,
  };
};

export const mapDispatchToProps = {
  ...ProtocolsStore.actionCreators,
  ...ProvidersStore.actionCreators,
  ...ProtocolConsumptionStore.ActionCreators,
};
